module.exports = __webpack_public_path__ + "static/media/career-developer.22c64842.jpg";